<template>
  <div class="operation-log">
    <panel-head title="操作日志" subtitle="OPERATION LOGS"></panel-head>
    <div class="panel-content">
      <h3 class="panel-content__title">操作日志</h3>
      <div class="panel-content__select-list">
        <ny-select class="mr20" :data="operationLog.searchMenu" v-model="operationLog.curSearch"></ny-select>
        <ny-date-range v-model="date" @change="dateChange" :shortcut="true" class="mr20"></ny-date-range>
        <el-button style="margin-top: -4px;" @click="handleSearch">查询</el-button>
      </div>
      <div class="panel-content__table-wrap">
        <ny-table
          :page="operationLog.page"
          @current-change="handlePageChange"
          @size-change="handlePageChange"
        ></ny-table>
      </div>
    </div>
  </div>
</template>
<script>
import { PanelHead, NySelect, NyDateRange, NyTable } from '@/global/components'
import Page from '@/global/util/Page'
import { mapGetters } from 'vuex'
export default {
  components: {
    PanelHead,
    NySelect,
    NyDateRange,
    NyTable
  },
  data () {
    return {
      date: [],
      page: new Page(),
      platform: undefined
    }
  },
  computed: {
    ...mapGetters({
      operationLog: 'global/operationLog/operationLog'
    })
  },
  created () {
    this.platform = this.$route.meta.platform
    this.init()
  },
  methods: {
    async init () {
      await this.$store.dispatch('global/operationLog/getSearchMenu', { platform: this.platform })
      this.getListData()
    },
    async getListData ({ pageSize, currentPage } = {}) {
      await this.$store.dispatch('global/operationLog/getListData', {
        platform: this.platform,
        params: {
          start_time: this.date.length > 1 ? this.date[0] : '',
          end_time: this.date.length > 1 ? this.date[1] : '',
          operate_type: this.operationLog.curSearch
        },
        perpage: pageSize,
        page: currentPage
      })
    },
    handleSearch () {
      this.getListData()
    },
    dateChange () {
    },
    handlePageChange ({ currentPage, pageSize }) {
      this.getListData({ currentPage, pageSize })
    }
  }
}
</script>
<style lang="scss">
@include b(operation-log) {
  .ny-date-range {
    display: inline-block;
  }
  .el-table__row {
    .cell {
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
